export const mockResponseQuotePhoneListValidateotp = {
    data: {
        quoteId: "0Q0dq0000004lwPCAQ",
        message: "Envío de código OTP exitoso",
        ApplicationId: 3945751,
        OTPCode: "715333"
    },
    error: "false"
}

// errores de mock datos inquilino  pantalla 3

export const mockOtppantalla1Error1 = { // probado
    data: {
        quoteId: "0Q0dq0000006w1JCAQ",
        message: "No reconoce el número",
        ApplicationId: 3945751
    },
    error: true
}

export const mockOtppantalla1Error2 = {
    data: {
        quoteId: "0Q0dq0000001MrJCAU",
        message: "No se seleccionó el número de teléfono",
        ApplicationId: 3945751
    },
    error: true
}

export const mockOtppantalla1Error3 = {
    data: {
        quoteId: "0Q0dq0000001MrJCAU",
        message: "Error del sistema de OTP",
        ApplicationId: 3945751
    },
    error: true
}

export const mockOtppantalla1Error4 = {
    data: {
        quoteId: "0Q0dq0000001MrJCAU",
        message: "Bypass del OTP debido a que el código no fue recibido",
        ApplicationId: 3945751
    },
    error: true
}

export const mockOtppantalla1Error5 = {
    data: {
        quoteId: "0Q0dq0000001MrJCAU",
        message: "Validación fallida debido a código incorrecto",
        ApplicationId: 3945751
    },
    error: true
}

export const mockOtppantalla1Error6 = {
    data: {
        quoteId: "0Q0dq0000001MrJCAU",
        message: "No cuenta con número telefónicos o correos electrónicos asociados al titular",
        ApplicationId: 3945751
    },
    error: true
}

export const mockotp1404 = {
    data: {
        quoteId: "0Q0dq0000004lwPCAQ",
        message: "Error 400 del servidor",
        ApplicationId: 3945751
    },
    error: true
}

